(ns ycweb.app.website.cookiebanner.cookiebanner
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc cookiebanner < rum/reactive [app-atom]
  (let [cookie-seen? (cmn/get-cookie-reactive app-atom :cookie_bar_seen)]
    (when-not cookie-seen?
      [:div.cookie-banner-wrapper
       [:div.cookie-banner
        [:div
         {:class (u/bem :flex-grid-group [:valign-bottom :m-no-wrap])}
         [:div
          {:class (u/bem :flex-grid-block [:m-fluid :m-grow-1])}
          [:div.flex-grid-content
           (headings/heading "We use cookies 🍪" {:type :h2 :size :small})
           [:p
            {:class (u/bem :yc-paragraph [:flush :small])}
            "We use cookies to ensure you get the best possible experience. By using this site we assume your consent, view our "
            [:a.text-link
             (urlstate/href-props app-atom "help" "article" {:id 191 :name "Yuppiechef-Privacy-Policy"})
             "Privacy Policy"]
            " for more info"]]]
         [:div
          {:class (u/bem :flex-grid-block [:m-fluid :m-shrink-0])}
          [:div.flex-grid-content
           (buttons/button-web "Got it"
             {:on-click #(u/set-cookie! app-atom :cookie_bar_seen true)
              :style :primary
              :size :default
              :full true
              :class "cookie-banner__button"})]]]]])))

(defmethod flow/render-screen :web.cookiebanner [app-atom _]
  (cookiebanner app-atom))

